const styles = {
  label: {
    width: '33%',
    flexShrink: 0,
  },
};

export default styles;
